import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TableCell } from '@nagel-types';
import { ChipComponent } from '../../../../chip/chip.component';
import { toCellText } from '../../table-cell-value.utils';

@Component({
    selector: 'app-chip-cell',
    imports: [ChipComponent],
    templateUrl: './chip-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipCellComponent {
    cell = input.required<TableCell>();

    readonly text = computed(() => toCellText(this.cell().value));
}
